import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

/**
 * The code browser now lives on the app detail page (GitHub-style: code is the
 * primary view). This route redirects so old links keep working.
 */
export const Route = createFileRoute("/apps/$appId/code")({
  component: () => {
    const { appId } = Route.useParams();
    const navigate = useNavigate();
    useEffect(() => {
      void navigate({ to: "/apps/$appId", params: { appId }, replace: true });
    }, [appId, navigate]);
    return null;
  },
});
